<div class="creation-wallet">
  <form
    [formGroup]="createWalletForm"
    class="flex flex--column flex--box"
    (ngSubmit)="onSubmit()"
  >
    <h3 class="text--upper_case text--center">Add Bank Account</h3>

    <div class="bank-image-block">
      <img src="assets/image/bank_icon.png" alt="">
    </div>

    <div class="flex flex--column">
      <div class="flex flex--column flex--box column--first">
        <!-- Address -->
        <div class="flex flex--column cars--input">
          <mat-form-field>
            <input type="text" formControlName="firstName" matInput placeholder="First Name"/>
          </mat-form-field>
        </div>
        <!-- Address -->

        <!-- City -->
        <div class="flex flex--column cars--input">
          <mat-form-field>
            <input type="text" formControlName="lastName" matInput placeholder="Last Name"/>
          </mat-form-field>
        </div>
        <!-- City -->

        <!-- State -->
        <div class="flex flex--column cars--input">
          <mat-form-field>
            <input type="text" formControlName="ownershipType" matInput placeholder="Type"/>
          </mat-form-field>
        </div>
        <!-- State -->

        <!-- ZIP Code -->
        <div class="flex flex--column cars--input">
          <mat-form-field>
            <input type="text" formControlName="businessName" matInput placeholder="Business name"/>
          </mat-form-field>
        </div>
        <!-- ZIP Code -->
      </div>

      <div class="flex flex--column flex--box">
        <!-- Company name -->
        <div class="flex flex--column cars--input">
          <mat-form-field>
            <input type="text" formControlName="accountNumber" matInput placeholder="Account number"/>
          </mat-form-field>
        </div>
        <!-- Company name -->

        <!-- Contact name -->
        <div class="flex flex--column cars--input">
          <mat-form-field>
            <input type="text" formControlName="routingNumber" matInput placeholder="Routing number"/>
          </mat-form-field>
        </div>
        <!-- Contact name -->

        <!-- Contact email -->
        <div class="flex flex--column cars--input">
          <mat-form-field>
            <input type="text" formControlName="streetAddress" matInput placeholder="Street address"/>
          </mat-form-field>
        </div>
        <!-- Contact email -->

        <!-- Contact email -->
        <div class="flex flex--column cars--input">
          <mat-form-field>
            <input type="text" formControlName="locality" matInput placeholder="City"/>
          </mat-form-field>
        </div>
        <!-- Contact email -->

        <!-- Contact email -->
        <div class="flex flex--column cars--input">
          <app-state-control formControlName="region">
          </app-state-control>
        </div>
        <!-- Contact email -->

        <!-- Contact email -->
        <div class="flex flex--column cars--input">
          <mat-form-field>
            <input type="text" formControlName="postalCode" matInput placeholder="Zip Code"/>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="flex flex__justify-content--center">
      <button
        type="submit"
        [disabled]="createWalletForm.invalid"
        class="text--upper_case"
        mat-raised-button
        color="primary"
      >
        Create
      </button>
    </div>
  </form>
</div>
